import React, { createContext, useState, useContext, useCallback } from 'react';

const PointPreviewContext = createContext();

export const PointPreviewProvider = ({ children }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [previewPoint, setPreviewPoint] = useState(null);
  const [onPreviewAction, setOnPreviewAction] = useState(null);
  const [onNavigationAction, setOnNavigationAction] = useState(null);

  // Use useCallback to memoize these functions
  const openPreview = useCallback((point, actionCallback, navigation = false, navigationCallback = null) => {
    setPreviewPoint(point);
    setOnPreviewAction(() => actionCallback); // Store the callback function
    if (navigation) {
      setOnNavigationAction(() => navigationCallback);
    }
    setIsPreviewOpen(true);
  }, []);

  const closePreview = useCallback(() => {
    setIsPreviewOpen(false);
    setPreviewPoint(null);
    setOnPreviewAction(null);
    setOnNavigationAction(null);
  }, []);

  // Create a value object that doesn't change on every render
  const contextValue = React.useMemo(() => ({
    isPreviewOpen,
    previewPoint,
    onPreviewAction,
    onNavigationAction,
    openPreview,
    closePreview
  }), [isPreviewOpen, previewPoint, onPreviewAction, onNavigationAction, openPreview, closePreview]);

  return (
    <PointPreviewContext.Provider value={contextValue}>
      {children}
    </PointPreviewContext.Provider>
  );
};

export const usePointPreview = () => {
  const context = useContext(PointPreviewContext);
  if (!context) {
    throw new Error('usePointPreview must be used within a PointPreviewProvider');
  }
  return context;
}; 